import { Pipe, PipeTransform } from '@angular/core';
import { TimeFilter, Filter, FilterTypes } from '@models/filter-types';

@Pipe({
    name: 'isTimeFilter',
    standalone: false,
})
export class IsTimeFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is TimeFilter {
        return value?.Type === FilterTypes.TimeFilterType;
    }
}
